import AlertNotificationModal from './AlertNotificationMoal'

export default AlertNotificationModal
